import React, { useState } from 'react'
import { getSafeImageUrl, handleImageError } from '../utils/imageUtils'

interface SafeImageProps {
  src: string | null | undefined
  alt: string
  className?: string
  category?: string
  fallbackText?: string
}

export const SafeImage: React.FC<SafeImageProps> = ({ 
  src, 
  alt, 
  className = '', 
  category,
  fallbackText = 'No image available'
}) => {
  const [hasError, setHasError] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  
  const safeSrc = getSafeImageUrl(src, category)
  
  const handleError = (event: React.SyntheticEvent<HTMLImageElement>) => {
    setHasError(true)
    setIsLoading(false)
    handleImageError(event, category)
  }
  
  const handleLoad = () => {
    setIsLoading(false)
    setHasError(false)
  }
  
  if (hasError) {
    return (
      <div className={`flex items-center justify-center bg-gray-100 ${className}`}>
        <span className="text-gray-500 text-sm">{fallbackText}</span>
      </div>
    )
  }
  
  return (
    <div className={`relative ${className}`}>
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        </div>
      )}
      <img
        src={safeSrc}
        alt={alt}
        className={`${className} ${isLoading ? 'opacity-0' : 'opacity-100'} transition-opacity duration-200`}
        onError={handleError}
        onLoad={handleLoad}
      />
    </div>
  )
} 